import React from 'react';
import { Users, UserCircle } from 'lucide-react';

const TeamTab = ({ selectedUser, myTeam, teamMembers, onRefresh }) => {
  if (!myTeam) {
    return (
      <div className="bg-white rounded-lg border border-gray-200 p-12 text-center">
        <Users className="h-12 w-12 text-gray-400 mx-auto mb-4" />
        <p className="text-gray-600">No team found</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="bg-white rounded-lg border border-gray-200 p-6">
        <h2 className="text-xl font-bold text-gray-900 mb-4">{myTeam.team_name}</h2>
        <p className="text-gray-600 mb-4">{myTeam.description}</p>
        
        <h3 className="font-semibold text-gray-900 mb-3">Team Members ({teamMembers.length})</h3>
        <div className="space-y-2">
          {teamMembers.map(member => (
            <div key={member.id} className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg">
              <UserCircle className="h-8 w-8 text-blue-600" />
              <div>
                <p className="font-medium text-gray-900">{member.full_name}</p>
                <p className="text-xs text-gray-600">{member.email}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TeamTab;
